import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dragScroll]',
  standalone: true,
})
export class DragScrollDirective {
  private isDown = false;
  private startX = 0;
  private scrollLeft = 0;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onDown(e: MouseEvent | TouchEvent) {
    this.isDown = true;
    this.renderer.addClass(this.el.nativeElement, 'dragging');
    this.startX = this.getX(e) - this.el.nativeElement.offsetLeft;
    this.scrollLeft = this.el.nativeElement.scrollLeft;
  }

  @HostListener('mouseleave')
  @HostListener('mouseup')
  @HostListener('touchend')
  onUp() {
    this.isDown = false;
    this.renderer.removeClass(this.el.nativeElement, 'dragging');
  }

  @HostListener('mousemove', ['$event'])
  @HostListener('touchmove', ['$event'])
  onMove(e: MouseEvent | TouchEvent) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = this.getX(e) - this.el.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 1; // Faktor = Geschwindigkeit
    this.el.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  private getX(e: MouseEvent | TouchEvent): number {
    return e instanceof MouseEvent ? e.pageX : e.touches[0].pageX;
  }
}
